<template>
    <b-modal
        :id="modalUUid"
        :ref="modalUUid"
        title="Require FaceTec Verification?"
        :hide-footer="true"
    >
        <p>Are you sure you want to require FaceTec verification for this user?</p>
        <div>
            <b-button variant="primary" @click="confirm" :disabled="loading" class="mr-1">
                Yes
            </b-button>
            <b-button variant="warning" @click="cancel">
                No
            </b-button>
        </div>
    </b-modal>
</template>

<script>
export default {
  props: {
    userId: {
      required: true,
      type: Number
    }
  },
  data () {
    return {
      modalUUid: `require-facetec-modal${this.userId}`,
      loading: false
    }
  },
  methods: {
    show () {
      this.$bvModal.show(this.modalUUid)
    },
    cancel () {
      this.$bvModal.hide(this.modalUUid)
    },
    async confirm () {
      this.loading = true
      try {
        await this.$http.post(`/api/user/${this.userId}/require-facetec`)
        this.$bvModal.hide(this.modalUUid)
        this.$emit('changed')
      } catch (error) {
        const message = error?.response?.data?.message || error?.response?.data?.errors || 'Failed to require FaceTec verification.'
        this.alertError(message)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
